import React, { useState, useCallback } from "react"
import "./TableStyles.scss"
import { Tbody, Tr, Box, Td, Flex } from "@chakra-ui/react"

import { StyledTd } from "./TableStyles"
import Menu from "components/UI/atoms/Menu"
import Icon from "components/UI/atoms/Icon"
import { IRoles } from "types/shared"

const TableContent = ({
  data,
  columns,
  actions,
  nestedColumns,
  insideActions,
  collapseButton,
  userRole,
  isReportsPage
}: any) => {
  const [nestedContainerHeight, setNestedContainerHeight] = useState(0)
  const nestedContainer = useCallback((node: any) => {
    if (node !== null) {
      setNestedContainerHeight(node.getBoundingClientRect().height + 60)
    }
  }, [])
  const [collapsedItems, setCollapsedItems] = useState<number[]>([])
  const handleRowClick = (id: number) => {
    if (collapsedItems.includes(id)) {
      setCollapsedItems((currentItems) =>
        currentItems.filter((item) => item !== id),
      )
    } else {
      setCollapsedItems((currentItems) => [...currentItems, id])
    }
  }

  const generateColumnBackgroundColor = (item: any) => {
    if (userRole === IRoles.WASHER_MANAGER && item.isPrinted) {
      return "#00875a"
    }
    if (userRole === IRoles.CASHIER) {
      if (item.isPrinted) {
        return "#00875a"
      } else if (item.vehicleKeyPresent && !item.isPrinted) {
        return "#f1c40f"
      } else {
        return "#dd5a4d"
      }
    }


    if (item.webReservation) {
      return "#08BA3626"
    } else {
      return ""
    }
  }



  const renderColumn = (column: any, item: any, hasNested: boolean) => {
    return isReportsPage ? <Td
      style={{
        padding: 0,
        fontSize: "12px",
        fontFamily: "sans-serif",
        color: "#000000",
        lineHeight: "14px"
      }}>
      {column.render(item, collapsedItems.includes(item.id))}
    </Td> :

      <StyledTd
        key={column.key}
        onClick={() => (column.hasClick ? handleRowClick(item.id) : {})}
        verticalAlign={`${(hasNested && collapsedItems.includes(item.id)) ? "sub" : ""}`}
        cursor={column.hasClick ? "pointer" : "auto"}
        {...column.styles}
      >
        {column.render(item, collapsedItems.includes(item.id))}
      </StyledTd>
  }
  return (
    <Tbody className="table-tiny" height={data.length <= 2 ? "200px" : ""}>
      {data.map((item: any) => (
        <Tr
          key={item.id}
          position="relative"
          height={`${nestedContainerHeight > 0 && collapsedItems.includes(item.id) && `${nestedContainerHeight}px`}`}
          backgroundColor={generateColumnBackgroundColor(item)}
          dropShadow={item.webReservation ? "#E9F2FD" : ""}
        >

          {columns.map((column: any) => renderColumn(column, item, nestedColumns.length > 0))}
          {insideActions && insideActions.length > 0 && (
            <StyledTd verticalAlign={`${nestedColumns.length === 0 ? "" : "sub"}`}>
              <Flex alignItems="center" gap="15px">
                {insideActions.map((insideAction: any) => (
                  <React.Fragment key={insideAction.key}>
                    {insideAction.render(item)}
                  </React.Fragment>
                ))}
              </Flex>
            </StyledTd>
          )}
          {actions && actions.length > 0 && (

            <StyledTd
              width="30px"
              colSpan={5}
              textAlign="right"
              verticalAlign={`${(nestedColumns.length > 0 && collapsedItems.includes(item.id)) ? "sub" : "middle"}`}
            ><>
                <Menu
                  menuIteHeight="45px"
                  menuTitle={<Icon name="dots" iconStyles={{ fill: "grey" }} />}
                  menuItems={actions.map((action: any) => ({
                    id: action.key,
                    text: action.render(item),
                    onClick: () => action.onClick(item)
                  }))}
                />
              </>
            </StyledTd>

          )}
          {collapseButton && (
            <StyledTd
              w="30px"
              cursor="pointer"
              onClick={() => handleRowClick(item.id)}
              verticalAlign={`${(nestedColumns.length > 0 && collapsedItems.includes(item.id)) ? "sub" : "middle"}`}
            >
              <Box transform={`${collapsedItems.includes(item.id) ? "rotate(180deg)" : ""}`}>
                <Icon name="arrowDown" iconStyles={{ width: "20px", height: "43px", fill: "#7D90A8" }} />
              </Box>
            </StyledTd>
          )}
          {nestedColumns.length > 0 && collapsedItems.includes(item.id) && (
            <Td
              position="absolute"
              left="0"
              bottom="10px"
              width="100%"
              padding="10px 15px"
              fontSize="base"
              ref={nestedContainer}
            >
              <Flex
                backgroundColor="input_border_color_primary"
                justifyContent="space-between"
                padding="15px"
                borderRadius="25px"
                width="100%"
              >
                {nestedColumns.map((nestedColumn: any) => (
                  <Flex
                    key={nestedColumn.key}
                    width="100%"
                    fontSize="base"
                    {...nestedColumn.styles}
                  >
                    <Box>
                      {nestedColumn.render(item)}
                    </Box>
                  </Flex>
                ))}
              </Flex>
            </Td>
          )}
        </Tr>
      ))}
    </Tbody>
  )
}

export default TableContent
